import { paletteBase } from '@abg/kit-base';

export const ChipWrapper = {
  fontFamily: 'inherit',
  fontWeight: 400,
  fontSize: '11px',
  lineHeight: '16px',
  height: '32px',
  padding: '10px',
  display: 'flex',
  borderRadius: '16px',
  color: paletteBase.black,
  background: {
    xs: paletteBase.neutral200,
    lg: paletteBase.white40,
  },

  '> svg': {
    fontSize: '16px !important',
  },
  '>span': {
    fontFamily: 'inherit',
    fontWeight: 400,
    fontSize: '11px',
    lineHeight: '16px',
    textTransform: 'initial',
    marginRight: '5px',
  },
};
